import { Component } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { AuthService } from '../Services/auth';
import { UserService } from '../Services/user';
import { ProductService } from '../Services/product';
import { CategoryService } from '../Services/category';
import { MessageService } from '../Services/message';
import { AlertService } from '../Services/alert';
import { LanguageService } from '../Services/lang';
import { CartService } from '../Services/cart';
import { ImageUtils } from '../Services/imageutils';
import { User } from '../Models/user';
import { Cart } from '../Models/cart';
import { Product } from '../Models/product';
import { Language } from '../Models/language';
import { Message } from '../Models/message';
import { Category } from '../Models/category';


@Component({
  selector: 'app-nav',
  templateUrl: '../Templates/nav.html',
  styleUrls: ['../Styles/nav.css']
})

/**
 * Implementation of navbar component.
 */
export class NavComponent {

  user: User;
  cart: Cart;
  wishlist: Product[];
  languages: Language[];
  activeDropdown: string;
  language: Language;
  messages: Message[];
  categories: Category[];
  unseenMessages: number;
  mainNavShown: false;
  dropDownStates = {};

  constructor(private authService: AuthService,
              private userService: UserService,
              private productService: ProductService,
              private msg: MessageService,
              private alerts: AlertService,
              private categoryService: CategoryService,
              private imageUtils: ImageUtils,
              private lang: LanguageService,
              private router: Router,
              private cartService: CartService) { }

  ngOnInit() {

    this.authService.getUser().subscribe(
      user => {
        this.user = user;

        // This may be the case: initially the auth service returns null.
        if (!this.user) {
          return;
        }

        if (this.user._links.wishlist) {
          this.userService.getWishlist(this.user).subscribe(
            data => { this.wishlist = data }
          );
        }

        try {
          this.msg.list(user).subscribe(
            data => {
              this.messages = data['results'];
              this.unseenMessages = this.messages.filter(
                msg => !msg.seen).length;
            }
          );
        } catch(e) {
          // no messages
        }

        this.userService.wishlistChanged$.subscribe(
          data => {
            this.userService.getWishlist(this.user).subscribe(
              data => { this.wishlist = data }
            );
          }
        );
      }
    );

    this.cartService.getCart().subscribe(
      cart => { this.cart = cart }
    );

    this.lang.list().subscribe(
      data => { this.languages = data }
    );

    this.lang.getLanguage().subscribe(
      data => { this.language = data; }
    );

    this.categoryService.list().subscribe(
      data => { this.categories = data['results']; }
    );
  }

  isOpen(item: string) {
    let val = item in this.dropDownStates ? this.dropDownStates[item] : false;
    return val;
  }

  toggleOpen(item: string, newState?: boolean): void {
    let state = item in this.dropDownStates ? this.dropDownStates[item] : false;
    state = !state;
    if (newState !== undefined) {
      state = newState;
    }
    this.dropDownStates[item] = state;
  }

  setLanguage(language: Language) {

    this.lang.setLanguage(language);
    this.dropDownStates['lang'] = false;
  }

  isActive(id: string): boolean {
    return this.activeDropdown == id;
  }

  toggleDropdown(id: string) {
    if (this.activeDropdown == id) {
        this.activeDropdown = null;
    } else {
      this.activeDropdown = id;
    }
  }

  closeDropdown(id: string) {
    if (this.activeDropdown == id) {
        this.activeDropdown = null;
    }
  }

  canLogout(user): boolean {
    try {
      return user._links.logout;
    } catch (e) {
      return false;
    }
  }

  canUnFollow(product): boolean {

    try {
      return product._links.unfollow != undefined;
    } catch(e) {
      return false;
    }
  }

  unFollow(product, idx): void {

    this.productService.unFollow(product).subscribe(
      product => {
        this.userService.unfollowing(product);
        this.alerts.success("Product removed from wishlist")
        this.wishlist.splice(idx, 1);
      },
      err => {
        this.alerts.error("Could not remove from wishlist")
      }
    );
  }

  logout(user): void {
    this.authService.logout(user);
    this.router.navigate(['/']);
  }

  validUser(user: User): boolean {
    return (user && !user.is_tmp);
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/nav.ts